import axios from "axios";

import { TOKEN_KEY } from "../../authProvider";

// Cloud Run rejects request bodies over 32 MiB, so the file goes straight to
// GCS with a signed PUT url; only the small signing request hits the API.
export const uploadDigitalPublicationViaSignedUrl = async (
  apiUrl: string,
  file: File
) => {
  const contentType = file.type || "application/octet-stream";
  const token = localStorage.getItem(TOKEN_KEY);

  const { data } = await axios.post(
    `${apiUrl}/upload/digital/publication/signed-url`,
    { fileName: file.name, contentType },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  // the signed url binds the content type; the PUT must send the same value
  await axios.put(data.signedUrl, file, {
    headers: { "Content-Type": contentType },
  });

  return { fileName: data.fileName };
};
